import { render, staticRenderFns } from "./IlluDateFavorite.vue?vue&type=template&id=1e1ac3ac&"
import script from "./IlluDateFavorite.vue?vue&type=script&lang=js&"
export * from "./IlluDateFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports